import { transformPromotedSpecialtiesForTopNavExp } from '../../../../../Homepage/transformPromotedSpecialtiesForTopNavExp';
import { useDesktopTopNav } from '../../../../Experiments/DesktopTopNavExperiment';
import { useFetchedJson } from '../../../../services/NetworkService';
import { env } from '../../../../util/env';
import { SearchPromotionResponseValidator } from '../EmptySearchSuggestions/SearchPromotionResponse.type';
import {
  Container,
  PillContainer,
  StyledTopServicesBox,
  Title,
  SubTitle,
  Header,
} from './EmptySearchSuggestionsSearchBar.styles';

interface Props {
  setValue: Setter<string>;
}

export const EmptySearchSuggestionsSearchBar = ({ setValue }: Props) => {
  const topNavExperiment = useDesktopTopNav();

  const fetched = useFetchedJson(
    `${env.MEGATRON_HOST}/api/4/search/promoted`,
    SearchPromotionResponseValidator,
  );

  if (!fetched.data) return null;

  const specialties = topNavExperiment
    ? transformPromotedSpecialtiesForTopNavExp(fetched.data.data)
    : fetched.data.data;

  return (
    <Container>
      <Header>
        <SubTitle>
          Search by service, practice or practitioner name, or specialisation/procedure.
        </SubTitle>
        <Title>Top services</Title>
      </Header>
      <PillContainer>
        {specialties.flatMap(item => {
          if (item.type !== 'specialty') return [];

          if (item.title === 'Dentistry') {
            item.title = 'Dentist';
          }

          return [
            <StyledTopServicesBox
              key={item.title}
              name={item.title}
              logoPath={item.icon}
              setValue={setValue}
              trackingId={`Search Bar Top Specialties - ${item.title}`}
            />,
          ];
        })}
      </PillContainer>
    </Container>
  );
};
